import {
  ChangeDetectionStrategy,
  Component,
  inject,
  OnInit,
  signal,
} from '@angular/core';
import {
  AutomationTrigger,
  AutomationTriggerConfig,
} from '@kinet-open-network/shared/data-access/model';
import { FieldChangeTriggerRuleGroupComponent } from '../../field-change-trigger/field-change-trigger-rule-group.component';
import {
  FieldChangeTriggerService,
  IFieldChangeRuleGroup,
} from '../../field-change-trigger/field-change-trigger.service';
import { TriggerComponent } from './abstract-trigger.component';

@Component({
  selector: 'kon-field-change-trigger',
  imports: [FieldChangeTriggerRuleGroupComponent],
  providers: [FieldChangeTriggerService],
  template: `
    <kon-field-change-trigger-rule-group
      [context]="automation.context"
      [group]="group()"
      [canDelete]="false"
      (groupChange)="handleGroupChange($event)"
    />
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FieldChangeTriggerComponent
  extends TriggerComponent<AutomationTrigger.FieldChange>
  implements OnInit
{
  readonly #service = inject(FieldChangeTriggerService);

  readonly group = signal<IFieldChangeRuleGroup>(
    this.#service.createRuleGroup(),
  );

  override ngOnInit(): void {
    const triggerData = this.automation.triggerData;
    if (triggerData) {
      this.group.set(triggerData as unknown as IFieldChangeRuleGroup);
    }
  }

  handleGroupChange(group: IFieldChangeRuleGroup): void {
    this.triggerChange.emit(
      group as unknown as AutomationTriggerConfig<AutomationTrigger.FieldChange>,
    );
  }
}
